<template>
    <b-button
            class="gofixButton gofixElement"
            v-bind:class="{
                gofixButtonLarge:large,
                gofixButtonSmall:small,
                gofixButtonUnsetMinWidth:unsetMinWith,
                gofixButtonWhiteSpace:whiteSpace,
                gofixButtonFontNormal:fontNormal,
                gofixButtonDark:dark,
                gofixButtonDisable:disabled,
                gofixButtonLoading:loading,
                gofixButtonNoBorder:noBorder,
                gofixButtonOutLine:outline,
                gofixButtonMarginTopFive:marginTopFive
            }"
            @click="handleClick">
        <b-spinner small type="grow" v-if="loading"></b-spinner>
        <span>
            <slot name="gofix:button:beforeLabel"></slot>
            <span v-html="label"></span>
            <slot name="gofix:button:afterLabel"></slot>
        </span>
    </b-button>
</template>

<script>
    export default {
        name: "buttons",
        props: {
            label: {
                type: String,
                required: false,
                default: () => "Button"
            },
            loading: {
                type: Boolean,
                required: false,
                default: () => false
            },
            outline: {
                type: Boolean,
                required: false,
                default: () => false
            },
            disabled: {
                type: Boolean,
                required: false,
                default: () => false
            },
            noBorder: {
                type: Boolean,
                required: false,
                default: () => false
            },
            dark: {
                type: Boolean,
                required: false,
                default: () => false
            },
            fontNormal: {
                type: Boolean,
                required: false,
                default: () => false
            },
            small: {
                type: Boolean,
                required: false,
                default: () => false
            },
            large: {
                type: Boolean,
                required: false,
                default: () => false
            },
            unsetMinWith: {
                type: Boolean,
                required: false,
                default: () => false
            },
            whiteSpace: {
                type: Boolean,
                required: false,
                default: () => false
            },
            marginTopFive: {
                type: Boolean,
                required: false,
                default: () => false
            },

        },

        data() {
            return {

            }
        },
        watch: {


        },
        created(){

        },
        methods: {
            handleClick(){
                if(this.disabled || this.loading) return;
                this.$emit("click");
            }
        }
    }
</script>

